import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Team = () => import('../views/team/Team.vue')
const Teams = () => import('../views/team/Teams.vue')
const Edit = () => import('../views/paper/Edit.vue')
const Paper = () => import('../views/paper/Paper.vue')
const Papers = () => import('../views/paper/Papers.vue')
const Callup = () => import('../views/Callup.vue')
const Entente = () => import('../views/Entente.vue')
const Stadium = () => import('../views/Stadium.vue')
const Palmares = () => import('../views/Palmares.vue')
const Gazettes = () => import('../views/Gazettes.vue')
const Arbitrage = () => import('../views/Arbitrage.vue')
const Photo = () => import('../views/photo/Photo.vue')
const Arbitre = () => import('../views/photo/Arbitre.vue')
const Article = () => import('../views/photo/Article.vue')
const Calendrier = () => import('../views/photo/Calendrier.vue')
const Club = () => import('../views/club/Club.vue')
const Bureau = () => import('../views/club/Bureau.vue')
const Contact = () => import('../views/club/Contact.vue')
const Statement = () => import('../views/club/Statement.vue')
const Training = () => import('../views/club/Training.vue')
const AssociativeProject = () => import('../views/club/AssociativeProject.vue')
const Formation = () => import('../views/club/Formation.vue')
const Codir = () => import('../views/club/Codir.vue')
//const Bilan = () => import('../views/club/Bilan.vue')
const Shop = () => import('../views/shop/Shop.vue')
// const HelloWorld = () => import('../views/HelloWorld.vue')

export function createRouter() {
  const router = new Router({
    //mode: 'history',
    mode: 'hash',
    base: '/app/',
    fallback: false,
    scrollBehavior: () => ({y: 0}),
    routes: [
      // {path: '/welcome', component: HelloWorld},
      {path: '/', component: Papers},
      {path: '/news', component: Papers},
      {path: '/news/:id', component: Paper},
      {path: '/edit', component: Edit},
      {path: '/edit/:id', component: Edit},
      {path: '/callup', component: Callup},
      {path: '/entente', component: Entente},
      {
        path: '/teams', component: Teams, children: [{
          path: '/teams/:id',
          component: Team
        }]
      },
      {
        path: '/photo', component: Photo, children: [{
          path: '/photo/arbitre',
          component: Arbitre
        }, {
          path: '/photo/article',
          component: Article
        }, {
          path: '/photo/calendrier',
          component: Calendrier
        }]
      }, {
        path: '/club', component: Club, children: [{
          path: '/club/bureau',
          component: Bureau
        },{
          path: '/club/contact',
          component: Contact
        },{
          path: '/club/statement',
          component: Statement
        },{
          path: '/club/training',
          component: Training
        },{
          path: '/club/AssociativeProject',
          component: AssociativeProject
        },{
          path: '/club/formation',
          component: Formation
        },{
          path: '/club/codir',
          component: Codir
        }/*,{
          path: '/club/bilan',
          component: Bilan
        }*/]
      },
      {path: '/stadium', component: Stadium},
      {path: '/arbitrage', component: Arbitrage},
      {path: '/palmares', component: Palmares},
      {path: '/gazettes', component: Gazettes},
      {path: '/shop', component: Shop},
    ]
  })
  router.afterEach((to, from) => {
    _.delay(() => {
      const view = window.location.hash.replace('#/', '');
      var search = "?u=" + view // + window.location.hash
      if (window.location.search !== search) {
        console.log(search)

        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + search;
        window.history.pushState({ path: newurl }, '', newurl);
        
        return
      }
    }, 200)  
    _.delay(() => {
      const a = _.map(Array.from(document.querySelectorAll("a")), "href")
      console.log("afterEach", to, from, a.splice(0, 2))
      console.log("afterEach", to, from)
    }, 1000)
  })
  return router;
}
